// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.maintenance-page {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
    padding: 30px;
    background: #101820;
    color: white;
}

.maintenance-page h1 {
    font-size: 32px;
    margin-bottom: 15px;
}

.maintenance-page p {
    color: #b8c2cc;
    max-width: 550px;
    line-height: 1.7;
}

.maintenance-image {
    width: 180px;
    height: 180px;
    object-fit: contain;
    margin-bottom: 25px;
}

.maintenance-footer {
    margin-top: 40px;
    color: #8b98a5;
}`, "",{"version":3,"sources":["webpack://./src/styles/MaintenancePage.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB","sourcesContent":[".maintenance-page {\r\n    min-height: 100vh;\r\n    display: flex;\r\n    flex-direction: column;\r\n    align-items: center;\r\n    justify-content: center;\r\n    text-align: center;\r\n    padding: 30px;\r\n    background: #101820;\r\n    color: white;\r\n}\r\n\r\n.maintenance-page h1 {\r\n    font-size: 32px;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.maintenance-page p {\r\n    color: #b8c2cc;\r\n    max-width: 550px;\r\n    line-height: 1.7;\r\n}\r\n\r\n.maintenance-image {\r\n    width: 180px;\r\n    height: 180px;\r\n    object-fit: contain;\r\n    margin-bottom: 25px;\r\n}\r\n\r\n.maintenance-footer {\r\n    margin-top: 40px;\r\n    color: #8b98a5;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
